import { Grid2 as Grid, Typography } from "@mui/material";
import React from "react";
import { CustomerModel } from "../../../../models/CustomerModels";
import { EditCustomerInfoButton } from "./EditCustomerInfoButton";

type Props = {
  customerDetails: CustomerModel;
};

export function ProductOrderRequirement({ customerDetails }: Props) {
  const renderContent = () => {
    if (typeof customerDetails.isProductOrderRequired !== "boolean") {
      return <Typography>N/A</Typography>;
    }

    return <Typography>{customerDetails.isProductOrderRequired ? "Yes" : "No"}</Typography>;
  };

  return (
    <Grid container={true} alignItems="center" justifyContent="end" flexWrap="nowrap">
      <Grid mr={0.5}>{renderContent()}</Grid>
      <EditCustomerInfoButton customer={customerDetails} />
    </Grid>
  );
}
